import { createApi } from '@reduxjs/toolkit/query/react';
import type { sessionData } from '../../api/userSessionContextParser';
import { createBaseQuery } from '../baseApi';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: createBaseQuery('auth/'),
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    loginUser: builder.mutation<sessionData, any>({
      query(data) {
        return {
          url: 'login',
          method: 'post',
          body: data,
        };
      },
      // transformResponse: (response: any) => userSessionContextparser(response),
    }),
    logoutUser: builder.mutation<void, void>({
      query() {
        return {
          url: 'logout',
          method: 'post',
        };
      },
    }),
  }),
});

export const { useLoginUserMutation, useLogoutUserMutation } = authApi;